import React from "react";
import { connect } from "react-redux";
import { Row, Col, Label, Input } from "reactstrap";
import { templateActions } from "../../../../../store/actions/cms/template/template.action";
import ColorPickerFacade from "../../../../../components/UI/Buttons/ColorPickerFacade";
import SystemLabel from "../../../../../system/SystemLabel/SystemLabel";
import JirangoFontPicker from "../../../../../fonts/FontPicker";
import { deepClone, setValueToNestedObject } from "../../../../../helpers/objectHelper";
import { FontWeightPicker } from "../../../../../fonts/FontWeightPicker/FontWeightPicker";
import { templateHelper } from "../../helpers/templateHelper";
import EditorSlider from "../../../../components/editor/tools/EditorSlider";
import BoxShadowSettings from "../../../../components/editor/BoxShadowSettings/BoxShadowSettings";
import JirangoSwitch from "../../../../../components/UI/Switch/JirangoSwitch";

class ButtonSettings extends React.Component {
  handleUpdate = (template) => {
    const { dispatch } = this.props;
    dispatch(templateActions.softUpdate(template));
  };
  handleSpaceOnChange = (e, path, dir) => {
    const { template } = this.props;
    const names = path.split(".");
    let templateCopy = deepClone(template);
    let spaceValue = templateCopy.content[names[0]][names[1]];
    if(spaceValue == 'unset') spaceValue = '0px 0px 0px 0px';

    let value = e.target.value;
    let splitted = spaceValue.toString().split(" ");
    if (splitted.length > 1) {
      splitted[dir] = value + "px";
      splitted = splitted.join(" ");
      templateCopy.content[names[0]][names[1]] = splitted;
    } else {
      let newString = `${splitted[0]}px ${splitted[0]}px ${splitted[0]}px ${splitted[0]}px`;
      newString = newString.split(" ");
      newString[dir] = value + "px";

      templateCopy.content[names[0]][names[1]] = newString.join(" ");
    }
    this.handleUpdate(templateCopy);
  };
  convertSpaceValue = (value, index) => {
    let splitted = value.toString().split(" ");
    if (splitted.length > 1) {
      return parseInt(splitted[index]);
    } else {
      return parseInt(splitted[0]);
    }
  };
  handleChange = (color, e, path, fallbackUnit = null) => {
    const { template } = this.props;
    const names = path.split(".");
    let templateCopy = deepClone(template);
    let value = templateHelper.getValueFromInput(e, color);
    let unit = templateHelper.getUnit(templateCopy, names);
    if (!unit && fallbackUnit) unit = fallbackUnit;
    if (!path.includes("hover")) {
      if (parseInt(value) && unit.length < 4) {
        value += unit;
      }
      templateCopy.content = deepClone(setValueToNestedObject(names, value, templateCopy.content));
    } else {
      templateCopy.content.button["&:hover"][names[2]] = value;
    }
    this.handleUpdate(templateCopy);
  };
  handleUnitChange = (unit, path) => {
    const { template } = this.props;
    const names = path.split(".");
    let templateCopy = deepClone(template);
    const value = templateHelper.getValueWithoutUnit(templateCopy, names);

    templateCopy.content = setValueToNestedObject(names, value + unit, templateCopy.content);

    if (unit === "auto") {
      templateCopy.content[names[0]][names[1]] = unit;
    }
    this.handleUpdate(templateCopy);
  };
  render() {
    const { template } = this.props;
    if (template === undefined) return null;
    return (
      <div style={{ paddingTop: "10px" }}>
        <Row>
          <Col className="list-setting-item-title">
            <Label>
              <SystemLabel name="TextColor" />
            </Label>
          </Col>
          <Col className="list-setting-item-input">
            <ColorPickerFacade color={template && template.content.button.color} onChange={(color, e) => this.handleChange(color, e, "button.color")} path="button.color" />
          </Col>
        </Row>
        <br />
        <Row>
          <Col className="list-setting-item-title">
            <Label>
              <SystemLabel name="BackgroundColor" />
            </Label>
          </Col>
          <Col className="list-setting-item-input">
            <ColorPickerFacade
              onClick={this.closeColorPickers}
              color={template && template.content.button.backgroundColor}
              onChange={(color, e) => this.handleChange(color, e, "button.backgroundColor")}
              path="button.backgroundColor"
            />
          </Col>
        </Row>
        <br />
        <Row>
          <Col className="list-setting-item-title">
            <Label>
              <SystemLabel name="HoverColor" />
            </Label>
          </Col>
          <Col className="list-setting-item-input">
            <ColorPickerFacade
              color={template ? template.content.button["&:hover"].color : ""}
              onChange={(color, e) => this.handleChange(color, e, "button.&:hover.color")}
              path={"buttonHover.color"}
            />
          </Col>
        </Row>
        <br />
        <Row>
          <Col className="list-setting-item-title">
            <Label>
              <SystemLabel name="HoverBackgroundColor" />
            </Label>
          </Col>
          <Col className="list-setting-item-input">
            <ColorPickerFacade
              color={template ? template.content.button["&:hover"].backgroundColor : ""}
              onChange={(color, e) => this.handleChange(color, e, "button.&:hover.backgroundColor")}
              path={"buttonHover.backgroundColor"}
            />
          </Col>
        </Row>
        <hr />
        <JirangoFontPicker onChange={this.handleChange} path="button.fontFamily" fontWeight={template.content.button.fontWeight} currentFontFamily={template && template.content.button.fontFamily} />
        <FontWeightPicker onChange={this.handleChange} path="button.fontWeight" currentFont={template.content.button.fontFamily} weight={template.content.button.fontWeight} />
        <br />
        <Row>
          <Col className="list-setting-item-title">
            <Label>
              <SystemLabel name="UpperCaseText" />
            </Label>
          </Col>
          <Col className="list-setting-item-input" style={{ textAlign: "right" }}>
            <JirangoSwitch
              onChange={() =>
                this.handleChange(null, template.content.button.textTransform === "none" || template.content.button.textTransform === "unset" ? "uppercase" : "unset", "button.textTransform")
              }
              isChecked={template.content.button.display === "uppercase"}
            />
          </Col>
        </Row>
        <hr />

        <EditorSlider
          value={templateHelper.getValueWithoutUnit(template, "button.fontSize")}
          defaultValue={0}
          unitChange={this.handleUnitChange}
          onChange={this.handleChange}
          units={["px", "rem", "em"]}
          activeUnit={templateHelper.getUnit(template, "button.fontSize")}
          steps={1}
          max={150}
          min={1}
          path={"button.fontSize"}
          label="FontSize"
        />
        <hr />
{/*         {selectedContainer.data.margin !== undefined ? ( */}
          <React.Fragment>
            <Row>
              <Col className="list-setting-item-title">
                <Label>
                  <SystemLabel name="Margin" />
                </Label>
              </Col>
            </Row>
            <Row>
              <Col className="list-setting-item-title" style={{ display: "inline-flex" }}>
                <div>
                  <Input autoComplete="jirango-nofill" type="number" onChange={(e) => this.handleSpaceOnChange(e, `button.padding`, 0)} value={this.convertSpaceValue(template.content.button.padding, 0)} />
                  <em>
                    <p style={{ textAlign: "center" }} className="text-muted">
                      <SystemLabel name="Top" />
                    </p>
                  </em>
                </div>
                <div>
                  <Input autoComplete="jirango-nofill" type="number" onChange={(e) => this.handleSpaceOnChange(e, `button.padding`, 1)} value={this.convertSpaceValue(template.content.button.padding, 1)} />
                  <em>
                    <p style={{ textAlign: "center" }} className="text-muted">
                      <SystemLabel name="Right" />
                    </p>
                  </em>
                </div>
                <div>
                  <Input autoComplete="jirango-nofill" type="number" onChange={(e) => this.handleSpaceOnChange(e, `button.padding`, 2)} value={this.convertSpaceValue(template.content.button.padding, 2)} />
                  <em>
                    <p style={{ textAlign: "center" }} className="text-muted">
                      <SystemLabel name="Bottom" />
                    </p>
                  </em>
                </div>
                <div>
                  <Input autoComplete="jirango-nofill" type="number" onChange={(e) => this.handleSpaceOnChange(e, `button.padding`, 3)} value={this.convertSpaceValue(template.content.button.padding, 3)} />
                  <em>
                    <p style={{ textAlign: "center" }} className="text-muted">
                      <SystemLabel name="Left" />
                    </p>
                  </em>
                </div>
              </Col>
            </Row>
          </React.Fragment>
      {/*   ) : null} */}

        <hr />
        <EditorSlider
          value={templateHelper.getValueWithoutUnit(template, "button.borderRadius")}
          defaultValue={0}
          unitChange={this.handleUnitChange}
          onChange={this.handleChange}
          units={["px", "rem", "em"]}
          activeUnit={templateHelper.getUnit(template, "button.borderRadius")}
          steps={1}
          max={150}
          min={1}
          path={"button.borderRadius"}
          label="BorderRadius"
        />
        <hr />
        <EditorSlider
          value={templateHelper.getValueWithoutUnit(template, "button.minHeight")}
          defaultValue={0}
          unitChange={this.handleUnitChange}
          onChange={this.handleChange}
          units={["px", "rem", "em"]}
          activeUnit={templateHelper.getUnit(template, "button.minHeight")}
          steps={1}
          max={150}
          min={1}
          path={"button.minHeight"}
          label="MinHeight"
        />
        <hr />
        <BoxShadowSettings
          boxShadowEnabled={template.content.button.boxShadow !== "unset" && template.content.button.boxShadow !== "none"}
          value={template.content.button.boxShadow}
          path={"button.boxShadow"}
          onChange={this.handleChange}
        />
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    alert: state.alert,
    template: state.template.template,
  };
}
export default connect(mapStateToProps)(ButtonSettings);
